















import { Component, Vue } from 'vue-property-decorator';
import { KonvaEventObject } from 'konva/types/Node';
import { gsap } from 'gsap';
import arrow from '../assets/sort-up-solid.svg';
import TimelineWrapper from './TimelineWrapper.vue';

@Component({
  components: {
    TimelineWrapper,
  },
})
export default class TimelinePanel extends Vue {
  toggleMinimized() {
    this.$store.dispatch('settings/toggleMinimized');
  }

  configTimelinePanel = {
    x: 0,
    y: window.innerHeight,
  };

  configBg = {
    x: 0,
    y: 0,
    width: window.innerWidth,
    height: 170,
    fill: '#e8e8e8',
    stroke: '#aeaeae',
    strokeWidth: 1,
    shadowColor: 'rgba(0,0,0,0.3)',
    shadowOffsetY: -20,
    shadowBlur: 100,
  };

  configMinimize = {
    image: new Image(),
    x: window.innerWidth - 25,
    y: 20,
    width: 20,
    height: 30,
    offset: {
      x: 10,
      y: 10,
    },
    rotation: 180,
  };

  addEvents(): void {
    window.addEventListener('resize', () => {
      this.configBg.width = window.innerWidth;
      this.configMinimize.x = window.innerWidth - 25;
    });
  }

  animateYOnLoad(): void {
    const pos = { y: this.configTimelinePanel.y };

    gsap.to(pos, {
      y: window.innerHeight - 170,
      duration: 1,
      ease: 'power3.out',
      onUpdate: () => (this.configTimelinePanel.y = pos.y),
    });
  }

  rotate(): void {
    const rotation = { rot: this.configMinimize.rotation };
    gsap.to(rotation, {
      rot: 180 - rotation.rot,
      duration: 0.5,
      onUpdate: () => (this.configMinimize.rotation = rotation.rot),
    });
  }

  minimize(): void {
    this.rotate();

    const pos = { y: this.configTimelinePanel.y };
    gsap.to(pos, {
      y:
        pos.y === window.innerHeight - 50
          ? window.innerHeight - 170
          : window.innerHeight - 50,
      duration: 1,
      ease: 'power3.out',
      onStart: () => this.toggleMinimized(),
      onUpdate: () => (this.configTimelinePanel.y = pos.y),
    });
  }

  changeCursor({ target }: KonvaEventObject<MouseEvent>, cursor: string): void {
    const container = target.getStage()?.container();
    if (container) container.style.cursor = cursor;
  }

  addImg(): void {
    this.configMinimize.image.src = arrow as string;
  }

  created() {
    this.addImg();
    this.addEvents();
  }

  mounted() {
    setTimeout(this.animateYOnLoad, 1000);
  }
}
